import { IProgramPeriod } from '../entity/program-period.interface';

export const periodSelectorFunction = (periods: IProgramPeriod[]) => {
  return periods?.length === 1
    ? periods[0]
    : periods.reduce((newest, current) => {
        return +new Date(newest.start) > +new Date(current.start) ? newest : current;
      }, periods[0]);
};
